import { FunctionComponent, lazy, Suspense, useEffect, useMemo, useRef } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../components/formulario/tableStyled";
import GetPresencaBatismo from "../services/services";
import LoadingGif from "../../../../components/loading";

export const Rows = lazy(() => import('./rows'));

interface TabelaPresencaBatismoProps {

}


const TabelaPresencaBatismo: FunctionComponent<TabelaPresencaBatismoProps> = () => {


  const {
    listAll,
    nextPagina,
    pagina,
  } = GetPresencaBatismo()

  const devRef = useRef<HTMLDivElement>(null);

  useMemo(() => {
    listAll?.slice(0, ((pagina + 1) * 30))
  }, [pagina]);


  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])


  return (<>
        <Tabler>
          <CorpoTable ref={devRef}>
            <Tabela>
              <>
                <TabelaCabeca>
                  <tr>
                    {
                      ["Nome", "Telefone", "E-mail", "Evento", "Batizado", "Presenca"]
                        ?.map(
                          res => <th>{res}</th>
                        )
                    }
                    <th></th>
                  </tr>
                </TabelaCabeca>
                <TabelaCorpo >
                  <Suspense fallback={<LoadingGif />}>
                    <Rows />
                  </Suspense>
                </TabelaCorpo>
              </>
            </Tabela>
          </CorpoTable>
        </Tabler>
  </>);
}

export default TabelaPresencaBatismo;
